export default __webpack_public_path__ + "static/media/Ben_Majekodunmi.33a65726.png";